import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ResolutionExportedInformSubmissionAuditItemDetails = ({ audit }) => (
  <div>
    <span>
      <AuditedUser audit={audit} /> included the resolution in an export of the form submission.
    </span>
  </div>
)

ResolutionExportedInformSubmissionAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ResolutionExportedInformSubmissionAuditItemDetails
